import React, { useState } from 'react';
import { Modal } from 'antd';
import { Copy, Check, AlertTriangle } from 'lucide-react';

/**
 * One-time reveal of a freshly created/rotated API key. The raw key is never
 * retrievable again, so this is the only chance to copy it.
 */
export default function McpKeyRevealModal({ open, apiKey, keyName, onClose }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(apiKey || '');
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      setCopied(false);
    }
  };

  return (
    <Modal
      open={open}
      title="Copy your API key now"
      onCancel={onClose}
      onOk={onClose}
      okText="I've saved it"
      cancelButtonProps={{ style: { display: 'none' } }}
      className="app-confirm-modal"
      centered
    >
      <div className="alert alert-warning d-flex align-items-start gap-2" role="alert">
        <AlertTriangle size={18} className="flex-shrink-0 mt-1" />
        <span>
          This is the only time the full key for <strong>{keyName || 'this credential'}</strong> is shown.
          Store it securely — you cannot retrieve it later (only rotate).
        </span>
      </div>
      <div className="input-group">
        <input type="text" className="form-control font-monospace" readOnly value={apiKey || ''} />
        <button type="button" className="btn btn-outline-secondary d-flex align-items-center gap-1" onClick={handleCopy}>
          {copied ? <Check size={15} /> : <Copy size={15} />}
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
    </Modal>
  );
}
